import styled from "styled-components";

export const Container = styled.div`
  margin-top: 30px;
`;

export const Label = styled.input`
  font-size: 14px;
  color: blue;
`;
